import React from "react";
import { Helmet } from "react-helmet";
import { AppMediaQuery } from "ui-components";

import AppHeader from "@common/components/AppHeader";
import Sidebar from "@previsit/components/Sidebar";
import Content from "@previsit/components/Content";
import { AppWrapper, ContentWrapper } from "@common/styled/app";

const App = () => {
  return (
    <AppWrapper>
      <Helmet>
        <title>Pre-Visit Assessment</title>
      </Helmet>
      <AppHeader />
      <AppMediaQuery>
        <ContentWrapper>
          <Sidebar />
          <Content />
        </ContentWrapper>
      </AppMediaQuery>
    </AppWrapper>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/previsit/components/App/App.jsx